import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ArrowUpGlyph = /*#__PURE__*/createElement("g", {
  id: "arrow_up"
}, /*#__PURE__*/createElement("path", {
  d: "M18,44.2c1.2,1.1,3.1,1.1,4.2-0.1L39,26.5V65c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3V26.5l16.7,17.6c1.1,1.2,3,1.2,4.2,0.1 c1.2-1.1,1.2-3,0.1-4.2l-21.9-23c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.3-0.2-0.4-0.2 c0,0-0.1,0-0.1,0C42.8,16.1,42.4,16,42,16c-0.4,0-0.8,0.1-1.2,0.2c0,0-0.1,0-0.1,0c-0.1,0.1-0.3,0.1-0.4,0.2 c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.2,0.2-0.3,0.2c0,0,0,0,0,0l-21.9,23C16.8,41.1,16.8,43,18,44.2z"
}));
const ArrowUp = createSvg({
  name: 'arrow_up',
  path: ArrowUpGlyph
});

export default ArrowUp;
export { ArrowUpGlyph };
